export default function changeCities() {
    const citiesUrlElement = document.getElementById("citiesUrl");

    if (!citiesUrlElement) return;

    const url = citiesUrlElement.value;

    document.querySelectorAll('select[name="state"]').forEach(stateElement => {
        stateElement.addEventListener('change', function () {
            const stateValue = this.value;

            fetch(url, {
                method: 'POST',
                headers: {
                    'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                body: `state=${encodeURIComponent(stateValue)}`,
            })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`Network response was not ok: ${response.statusText}`);
                }
                return response.text();
            })
            .then(html => {
                // Tenta encontrar o campo 'city' no mesmo container que o campo 'state'
                const container = stateElement.closest('form') || stateElement.parentElement;
                const cityElement = container.querySelector('select[name="city"]');
                if (cityElement) {
                    cityElement.innerHTML = html;
                }
            })
            .catch(error => {
                console.error("Error fetching cities:", error);
            });
        });
    });
}
